<section [formGroup]="stepForm"
         class="mbs-wizard_form">
  <ng-container *ngIf="(ability.can('read', 'Notification') || isProvider) && !isRDMode">

    <div class="mbs-form-group"
         [formGroup]="notificationForm"
         [attr.data-test-element]="elementsSelector.name.mainNotificationSwitch">
      <mbs-button-group [toggle]="true"
                        class="w-100"
                        customClasses="w-100">
        <mbs-button [type]="'secondary'"
                    class="flex-basis-50"
                    customClasses="w-100 justify-content-center"
                    [active]="!notificationFormEnabled"
                    (click)="notificationFormEnabled = false">
          {{ 'wizards:notification_company_label' | i18next }}
        </mbs-button>
        <mbs-button [type]="'secondary'"
                    class="flex-basis-50"
                    customClasses="w-100 justify-content-center"
                    [active]="notificationFormEnabled"
                    (click)="notificationFormEnabled = true">
          {{ 'wizards:notification_specify_label' | i18next }}
        </mbs-button>
      </mbs-button-group>
    </div>

    <p *ngIf="!notificationForm.get('enabled').value"
       class="mb-3">
      {{ 'wizards:notificationInfo1' | i18next }}
      <ng-container *ngIf="(companyId$ | async) as companyId;else noCompanyId">
        <a [routerLink]="[RoutingPath.ApCompanies, companyId]"
           [queryParams]="{ 'tab': (isBackupNotificationsMode ? 'notificationSettingsBackupTab' : 'notificationSettingsRestoreTab') }"
           target="_blank">
          {{ 'shared:notifications.notifications' | i18next }}
        </a>
      </ng-container>
      <ng-template #noCompanyId>
        {{ 'shared:notifications.notifications' | i18next }}
      </ng-template>
      {{ 'wizards:notificationInfo2' | i18next }}
    </p>

    <mbs-form-group class="mb-0">

      <ng-container *ngIf="notificationForm.get('enabled').value"
                    [ngTemplateOutlet]="notificationTemplate"
                    [ngTemplateOutletContext]="{ $implicit: notificationForm, readOnly: false }">
      </ng-container>

      <ng-container *ngIf="!notificationForm.get('enabled').value"
                    [ngTemplateOutlet]="notificationTemplate"
                    [ngTemplateOutletContext]="{ $implicit: globalNotificationForm, readOnly: true }">
      </ng-container>

      <ng-template #notificationTemplate
                   let-mainForm
                   let-readOnly="readOnly">

        <ng-container [formGroup]="mainForm">

          <mbs-card [hasPadding]="false"
                    customClasses="notification-card mb-3">
            <div class="p-3 d-flex align-items-center">
              <span class="ico ico-check-circle text-green text-xl pr-2 card-ico"></span>
              <h4 class="my-0">{{ 'shared:notifications.success' | i18next }}</h4>
            </div>
            <hr class="m-0 opacity-100">
            <mbs-notifications-checkboxes prefixId="{{ type }}-success"
                                          formControlName="success"
                                          cardMode="true"
                                          [readOnly]="readOnly">
            </mbs-notifications-checkboxes>
          </mbs-card>

          <mbs-card [hasPadding]="false"
                    customClasses="notification-card mb-3">
            <div class="p-3 d-flex align-items-center">
              <span class="ico ico-OverdueSettings pr-2 text-warning text-xl card-ico"></span>
              <h4 class="my-0">{{ 'shared:notifications.warning' | i18next }}</h4>
            </div>
            <hr class="m-0 opacity-100">
            <mbs-notifications-checkboxes prefixId="{{ type }}-warning"
                                          formControlName="warning"
                                          cardMode="true"
                                          [readOnly]="readOnly">
            </mbs-notifications-checkboxes>
          </mbs-card>

          <mbs-card [hasPadding]="false"
                    customClasses="notification-card mb-3">
            <div class="p-3 d-flex align-items-center">
              <span class="ico ico-failed pr-2 text-danger text-xl card-ico"></span>
              <h4 class="my-0">{{ 'shared:notifications.failed' | i18next }}</h4>
            </div>
            <hr class="m-0 opacity-100">
            <mbs-notifications-checkboxes prefixId="{{ type }}-failure"
                                          formControlName="failure"
                                          [addThresholdFailed]="isBackupNotificationsMode ? true : false"
                                          cardMode="true"
                                          hideThresholdM365Tooltip="true"
                                          [readOnly]="readOnly">
            </mbs-notifications-checkboxes>
          </mbs-card>

          <mbs-card *ngIf="false && isBackupNotificationsMode"
                    [hasPadding]="false"
                    customClasses="notification-card">
            <div class="p-3 d-flex align-items-center">
              <span class="ico ico-ClockO pr-2 text-danger text-xl card-ico"></span>
              <h4 class="my-0">{{ 'shared:notifications.noSuccess' | i18next }}</h4>
            </div>
            <hr class="m-0 opacity-100">
            <mbs-notifications-checkboxes formControlName="noSuccess"
                                          [addThresholdNoSuccess]="true"
                                          prefixId="{{ type }}-no-success"
                                          cardMode="true"
                                          hideThresholdM365Tooltip="true"
                                          [readOnly]="readOnly">
            </mbs-notifications-checkboxes>
          </mbs-card>
        </ng-container>
      </ng-template>
    </mbs-form-group>
  </ng-container>

  <ng-container *ngIf="(globalNotificationSettings$ | async)?.allowNotifyEndUsers">
    <mbs-form-group formGroupName="receiveNotificationOnCompleteGroup">
      <mbs-card [hasPadding]="false"
                customClasses="notification-card mt-3">
        <div class="p-3 d-flex align-items-center justify-content-between">
          <span class="font-weight-bold"
                container="body"
                [placement]="'top auto'"
                [ngbTooltip]="userNotificationTooltip">
            {{ 'wizards:notification_email_label' | i18next }}{{ userName }}
          </span>
          <ng-template #userNotificationTooltip>
            <div>
              <span>
                {{ 'wizards:notification_email_tooltip1' | i18next }}
              </span>
              <span class="font-weight-bold">
                {{ 'wizards:notification_email_tooltip2' | i18next }}
              </span>
              <span>
                {{ 'wizards:notification_email_tooltip3' | i18next }}
              </span>
            </div>
          </ng-template>
          <mbs-switcher formControlName="flag"
                        (change)="flagChangeHandler($event)"
                        [id]="'receiveNotificationOnCompleteGroup-add-flag-switcher'">
          </mbs-switcher>
        </div>
        <hr class="m-0 opacity-100">
        <div class="d-flex p-3">
          <mbs-radio formControlName="case"
                     name="receiveNotificationOnCompleteGroupAddCaseRadio"
                     value="whenFails"
                     class="radio_row"
                     [label]="isRestore ?
             ('wizards:restore_notification_when_fails' | i18next) :
             ('wizards:notification_email_when_fails_label') | i18next"
                     [id]="'receiveNotificationOnCompleteGroup-add-flag-radio-1'"></mbs-radio>
          <mbs-radio formControlName="case"
                     name="receiveNotificationOnCompleteGroupAddCaseRadio"
                     value="allCases"
                     class="radio_row pl-4"
                     [label]="'wizards:all_cases_label' | i18next"
                     [id]="'receiveNotificationOnCompleteGroup-add-flag-radio-2'"></mbs-radio>
        </div>
      </mbs-card>
    </mbs-form-group>
  </ng-container>
</section>
